export default __webpack_public_path__ + "static/facilities-img4-559b546bf4b2c3b66f8bd94b6ccc1e87.png";